var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 369.541,
    xmlns: "http://www.w3.org/2000/svg",
    height: 96.047,
    id: "screenshot-4c13bd60-082e-80ca-8002-435cda22ef61",
    viewBox: "-6.541 -26.047 369.541 96.047",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-435cda22ef61",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-435cda22efa7",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-435cda22efa9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-435cda22efa9"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M89.180,12.712C89.216,12.816,89.251,12.919,89.287,13.023L89.180,12.712ZM48.236,70.000L47.419,70.000C30.888,69.687,16.607,60.146,9.570,46.338L19.019,43.818C24.657,53.621,35.269,60.233,47.419,60.233L47.419,69.992M89.263,13.023L89.263,13.023Z",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-435cda22efaa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-435cda22efaa"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.44594594594605,
    ry: 11.39534883720927,
    cx: 11.44594594594605,
    cy: 21.162790697674666,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-435cda22efab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-435cda22efab"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M58.865,0.000C70.597,0.000,80.122,9.483,80.122,21.163L80.122,42.326L70.311,42.326L70.311,38.995C67.006,41.103,63.078,42.326,58.865,42.326C47.133,42.326,37.608,32.843,37.608,21.163C37.608,9.483,47.133,0.000,58.865,0.000ZM58.865,9.767C52.548,9.767,47.419,14.874,47.419,21.163C47.419,27.452,52.548,32.558,58.865,32.558C65.182,32.558,70.311,27.452,70.311,21.163C70.311,14.874,65.182,9.767,58.865,9.767Z",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-4c13bd60-082e-80ca-8002-435cda22efa8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-4c13bd60-082e-80ca-8002-435cda22efa8"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M320.486,19.535L325.392,19.535L325.392,42.326L320.486,42.326L320.486,19.535ZM194.581,0.000C206.313,0.000,215.838,9.483,215.838,21.163C215.838,32.843,206.313,42.326,194.581,42.326C182.849,42.326,173.324,32.843,173.324,21.163C173.324,9.483,182.849,0.000,194.581,0.000ZM194.581,4.884C185.557,4.884,178.230,12.178,178.230,21.163C178.230,30.147,185.557,37.442,194.581,37.442C203.606,37.442,210.932,30.147,210.932,21.163C210.932,12.178,203.606,4.884,194.581,4.884ZM112.824,0.000C124.556,0.000,134.081,9.483,134.081,21.163C134.081,32.843,124.556,42.326,112.824,42.326C101.092,42.326,91.568,32.843,91.568,21.163C91.568,9.483,101.092,0.000,112.824,0.000ZM112.824,4.884C103.800,4.884,96.473,12.178,96.473,21.163C96.473,30.147,103.800,37.442,112.824,37.442C121.849,37.442,129.176,30.147,129.176,21.163C129.176,12.178,121.849,4.884,112.824,4.884ZM358.095,19.535L363.000,19.535L363.000,42.326L358.095,42.326L358.095,19.535ZM289.419,0.000C301.151,0.000,310.676,9.483,310.676,21.163C310.676,32.843,301.151,42.326,289.419,42.326C277.687,42.326,268.162,32.843,268.162,21.163C268.162,9.483,277.687,0.000,289.419,0.000ZM289.419,4.884C280.394,4.884,273.068,12.178,273.068,21.163C273.068,30.147,280.394,37.442,289.419,37.442C298.443,37.442,305.770,30.147,305.770,21.163C305.770,12.178,298.443,4.884,289.419,4.884ZM305.770,19.535L310.676,19.535L310.676,42.326L305.770,42.326L305.770,19.535ZM341.743,4.585C332.719,4.585,325.392,11.433,325.392,19.868L325.392,32.558C322.329,29.115,320.486,24.691,320.486,19.868C320.486,8.903,330.011,0.000,341.743,0.000C353.475,0.000,363.000,8.903,363.000,19.868C363.000,24.691,361.157,29.115,358.095,32.558L358.095,19.868C358.095,11.433,350.768,4.585,341.743,4.585ZM91.568,19.535L96.473,19.535L96.473,55.349L91.568,55.349L91.568,19.535ZM160.243,4.990C153.462,6.509,148.351,13.121,148.351,21.037L148.351,34.634C145.567,30.945,143.892,26.205,143.892,21.037C143.892,10.402,150.987,1.577,160.243,0.000L160.243,4.990ZM143.892,21.037L148.351,21.037L148.351,42.326L143.892,42.326L143.892,21.037ZM224.768,0.000L219.108,0.000L243.635,42.326L268.162,0.000L262.502,0.000L243.635,32.558L224.768,0.000Z",
    style: {
      fill: "rgb(30, 41, 59)",
      fillOpacity: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.6b179c5109ec4be2fcf88d7c3ef288f5.svg";
export { ForwardRef as ReactComponent };